// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__2yKvm","title":"ClientCherryInfo_title__2H_MZ","itemText":"ClientCherryInfo_itemText__2Klww"};